import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { useErrorHandler } from '@wix/fe-essentials/react';
import { useQuery, useQueryClient } from '@wix/fe-essentials/react-query/react';
import { useCollapseItems } from '@wix/rules-panel-ui';
import { useShowFailedAnalyzeSiteModal } from '../components/modals/show-failed-analyze-site-modal';
import { SITE_LEVEL_PAGE_ID } from '../consts';
import { useScanTimeoutManager } from '../hooks/scan-timeout';
import { NotPublishedBranchIdError } from '../types';
import { useAnalyzeFullSite } from './analyze';
import { QueryId } from './types';
export const useAnalyzeFullSiteQuery = () => {
  const {
    analyzeFullSite
  } = useAnalyzeFullSite();
  const {
    setScanTimeoutForItemType,
    setPageScanTimeout
  } = useScanTimeoutManager();
  const {
    collapseGroup
  } = useCollapseItems();
  const showFailedAnalyzeSiteModal = useShowFailedAnalyzeSiteModal();
  const errorHandler = useErrorHandler();
  const {
    getResolvedError
  } = errorHandler;
  const queryClient = useQueryClient();
  return useQuery({
    enabled: false,
    queryFn: async () => {
      try {
        const jobs = await analyzeFullSite();
        collapseGroup();
        setScanTimeoutForItemType(ITEM_TYPES.STATIC_PAGE_V2);
        setPageScanTimeout(SITE_LEVEL_PAGE_ID);
        return jobs;
      } catch (error) {
        if (error instanceof NotPublishedBranchIdError) {
          return;
        }
        showFailedAnalyzeSiteModal({
          errorMessage: getResolvedError(error).message,
          handleTryAgain: () => {
            queryClient.refetchQueries([QueryId.AnalyzeFullSite]);
          }
        });
        throw error;
      }
    },
    queryKey: [QueryId.AnalyzeFullSite],
    refetchOnWindowFocus: false,
    retry: false
  });
};
//# sourceMappingURL=use-analyze-full-site-query.js.map